import React,{useState,useEffect} from 'react'
import { useAppData } from '../../../../../context/AppDataContext';

function POPaymentAnalytics({poList}) {

  const {vendorDD} = useAppData();
  
  const [vendorData,setVendorData] = useState(null)
  
  const prepareData = () =>{
      let _data =[];
      vendorDD.forEach((v,i)=>{
          _data[i] = v;
          _data[i].poCount = 0;
          _data[i].qty = 0;
          _data[i].totalPrice = 0;
          _data[i].gstAmount = 0;
          _data[i].paidAmount = 0;

          poList.forEach(po => {
            //console.log(po.vendorId, "==", _data[i].value)
            if(po.vendorId == _data[i].value) {
              _data[i].poCount = Number(_data[i].poCount + 1);
              _data[i].totalPrice = Number(_data[i].totalPrice+( po.price * po.qty ));
              _data[i].gstAmount = Number( _data[i].gstAmount + ( (po.price * po.qty * po.gstRate) / 100));
              //_data[i].grandTotal = Number(_data[i].grandTotal + ( po.totalPrice+ po.gstAmount));
              _data[i].paidAmount = Number(_data[i].paidAmount +po.paidAmount);
            }
          });
      })
      setVendorData(_data);
  }
  useEffect(()=>{
      if(poList){
          prepareData()
      }
  },[poList])
  


  return (
    poList &&
    <table className='table'>
      <thead>
        <tr><th colSpan={7}className='text-center table-dark' >Vendor PO Payment</th></tr>
          <tr>
              <th>Vendor Name</th>
              <th>Po Count</th>
              <th>Total Price</th>
              <th>Total Gst Amount</th>
              <th>Grand Total</th>
              <th>Total Paid Amount</th>
              <th>Diffrence </th>
          </tr>
        
        </thead>
        <tbody>
          {vendorData?.map(vendor=>
            vendor.totalPrice > 0 &&
            <tr key={vendor.value}>
              <td>{vendor.label}</td>
              <td>{vendor.poCount}</td>
              <td>{vendor.totalPrice}</td>
              <td>{vendor.gstAmount}</td>
              <td>{vendor.totalPrice+vendor.gstAmount}</td>
              <td>{vendor.paidAmount}</td>
              <td className={(vendor.totalPrice+vendor.gstAmount) - vendor.paidAmount < 0 && 'table-danger text-danger'}>
                
                {(vendor.totalPrice+vendor.gstAmount) - vendor.paidAmount}
                
                </td>
            </tr>
          )}
        </tbody>
      
    </table>
  )
}

export default POPaymentAnalytics